import React from "react";

const font = '"DM Sans", sans-serif';

function Bar({ pct, color = "#ff4b4f", height = 6, showLabel = true }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, width: "100%" }}>
      <div style={{ flex: 1, background: "rgba(0,0,0,0.08)", borderRadius: height / 2, height, overflow: "hidden" }}>
        <div style={{ width: `${pct}%`, height: "100%", background: color, borderRadius: height / 2, transition: "width 0.6s" }} />
      </div>
      {showLabel && (
        <span style={{ fontSize: 12, color: "#6b6b6b", minWidth: 36, textAlign: "right", fontFamily: font }}>
          {pct}%
        </span>
      )}
    </div>
  );
}

export default Bar;
